import { Injectable, EventEmitter, HostListener } from '@angular/core';
import { UserHelper } from './user.helper';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class RouteGuardHelper implements CanActivate {
  constructor(private _UserHelper: UserHelper, public _ApiService: ApiService, public _Router: Router) {}
  signOutRoute = ['/register', '/registersuccess', '/login'];
  signInRoute = ['/document', '/documentInfoUpload', '/documentInfo'];
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this._ApiService.getClient().then(result => {
      this._UserHelper.setUser(result);
      if (!result) {
        if (this.signInRoute.includes(state.url)) {
          this._Router.navigate(['home']);
          return false;
        } else {
          return true;
        }
      } else {
        if (this.signOutRoute.includes(state.url)) {
          this._Router.navigate(['home']);
          return false;
        }
      }
    });
    return true;
  }
}
